import { Warning } from '@mui/icons-material';
import classNames from 'classnames';

interface AlertProps {
  children: string;
  fullWidth?: boolean;
  color: 'blue' | 'red';
}

const colorMapping = {
  red: 'bg-danger-100',
  blue: 'bg-primary-100',
};

function Alert({ color, children, fullWidth = false }: AlertProps) {
  return (
    <div
      className={classNames(
        fullWidth && 'w-full',
        colorMapping[color],
        'rounded-md bg- p-4',
      )}
    >
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <Warning className="h-5 w-5" aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <div className="text-sm text-blue-700">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default Alert;
